export const defaultSelectedItem = () => {
  return {
    id_tipo_seguimiento: '',
    descripcion: '',
    opciones_mejora: '',
    legislacion: '',
    observaciones: '',
  }
}

export const filtro = () => {
  return {
    buscar: '',
    paginado: true,
    page: 1,
    perPage: 10,
    sortBy: 'id',
    sort: 'DESC',
  }
}

export default {
  selectedItem: defaultSelectedItem(),
  items: [],
  tipoSeguimientos: [],
  accion: 'Crear',
  error: false,
  filtro: filtro(),
  cargando: false
}
